import React from 'react';

export function renderCouponStatusText(coupon) {
  let status;
  let color;
  if (coupon.status === 'EXPIRED') {
    status = 'Expired';
    color = 'grey';
  } else if (
    !!coupon.global_quota &&
    coupon.used_quota >= coupon.global_quota
  ) {
    status = 'Out of quota';
    color = 'grey';
  } else if (coupon.status === 'OPEN') {
    status = 'Active';
    color = 'green';
  } else if (coupon.status === 'SUSPENDED') {
    status = 'Inactive';
    color = 'red';
  } else {
    status = coupon.status;
    color = 'initial';
  }

  return <span style={{ color }}>{status}</span>;
}

export function renderSubscriptionLength(coupon) {
  if (coupon.subscription_lengths && coupon.subscription_lengths.length > 0) {
    const [subcriptionLength] = coupon.subscription_lengths;
    return subcriptionLength;
  }

  return 'ANNUAL';
}
